/**
 * Feedback Item Component
 * Icon with optional label for feedback actions
 */

import React from 'react';
import {
  spacing,
  borders,
  backgroundColors,
  strokeColors,
  typographyColors,
  typography,
} from '@/design-system/utils';

export interface FeedbackItemProps {
  icon: React.ReactNode;
  label?: string;
  onClick?: () => void;
  disabled?: boolean;
}

export const FeedbackItem: React.FC<FeedbackItemProps> = ({
  icon,
  label,
  onClick,
  disabled = false,
}) => {
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      style={{
        display: 'flex',
        padding: `8px ${spacing[3]}`,
        justifyContent: 'center',
        alignItems: 'center',
        gap: spacing[2],
        borderRadius: borders.radius.lg,
        border: `${borders.width.thin} ${borders.style.solid} ${strokeColors.base}`,
        background: backgroundColors.offset,
        cursor: onClick && !disabled ? 'pointer' : 'default',
        transition: 'all 0.2s',
        outline: 'none',
      }}
      onMouseEnter={e => {
        if (onClick && !disabled) {
          e.currentTarget.style.opacity = '0.8';
        }
      }}
      onMouseLeave={e => {
        if (onClick && !disabled) {
          e.currentTarget.style.opacity = '1';
        }
      }}
    >
      {icon}
      {label && (
        <span
          style={{
            color: typographyColors.primary,
            fontFamily: typography.fonts.primary,
            fontSize: typography.size.base,
            fontStyle: 'normal',
            fontWeight: typography.weight.semibold,
            lineHeight: 'normal',
          }}
        >
          {label}
        </span>
      )}
    </button>
  );
};
